<ng-container *ngIf="serverError">
  <div class="modal-header">
    <h4 class="modal-title">Server Error: {{ serverError }}</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
</ng-container>

<ng-container *ngIf="!serverError">

  <div class="modal-header">
    <h4 class="modal-title">Purchase Voucher Pack</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">

    <div class="form-group">
      <label for="voucherPackSelect">Voucher Pack Type</label>
      <select id="voucherPackSelect" class="custom-select" name="voucherPack"
              [(ngModel)]="voucherPackId" required
              [disabled]="loadingVoucherPacks" [class.disabled]="loadingVoucherPacks">
        <option *ngIf="loadingVoucherPacks">Loading...</option>
        <option *ngIf="!loadingVoucherPacks" [value]="null">---</option>
        <option *ngFor="let voucherPackType of voucherPackList" [value]="voucherPackType.id">
          {{ voucherPackType.name }}
          <ng-container *ngIf="voucherPackType.status === VoucherPackStatus.retired">(Retired)</ng-container>
          <ng-container *ngIf="voucherPackType.status === VoucherPackStatus.draft">(Draft)</ng-container>
        </option>
      </select>
    </div>

    <div class="alert alert-danger" role="alert" *ngIf="errors.non_field_errors">
      {{ errors.non_field_errors }}
    </div>
    <div class="alert alert-danger" role="alert" *ngIf="errorMessage">
      {{ errorMessage }}
    </div>

    <p class="mb-0 mt-4">
      The button below will take you to the Climber App purchase page for the selected Voucher Pack, logged in as {{ customer.first_name }} {{ customer.last_name }}. From there you can complete the purchase.
    </p>

  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-secondary"
            (click)="activeModal.close()">
      Cancel
    </button>
    <button type="button" class="btn btn-primary"
            *ngIf="!(loadingVoucherPacks || loadingSubmit)"
            [disabled]="voucherPackId === null"
            [class.disabled]="voucherPackId === null"
            (click)="handleSave()">
      Go to Climber App
    </button>
    <button type="button" class="btn btn-primary disabled" disabled
            *ngIf="loadingVoucherPacks || loadingSubmit">
      Loading...
    </button>
  </div>

</ng-container>
